import "./App.css";
import bookList from "./booklistsept.json";
import React, { useState } from "react";
import Chip from "./Chip";
import openInNew from "./open_in_new.svg";
import arrowUpward from "./arrow_upward.svg";

export function App() {

    // Search
  let [searchTitleText, setSearchTitleText] = useState("");
  let [searchAuthorText, setSearchAuthorText] = useState("");
  const [selectedGenres, setSelectedGenres] = useState<string[]>([]);
  const [selectedHeritages, setSelectedHeritages] = useState<string[]>([]);

  function toggleGenre(genre: string) {
    setSelectedGenres((genres) =>
      genres.includes(genre)
        ? genres.filter((item) => item !== genre)
        : [...genres, genre]
    );
  }
  function toggleHeritage(heritage: string) {
    setSelectedHeritages((heritages) =>
      heritages.includes(heritage)
        ? heritages.filter((item) => item !== heritage)
        : [...heritages, heritage]
    );
  }

  const books = bookList
    .filter((book: any) =>
      book.title.toLowerCase().includes(searchTitleText.toLowerCase())
    )
    .filter((book: any) =>
      book.authorName.toLowerCase().includes(searchAuthorText.toLowerCase())
    )
    .filter((book: any) =>
      selectedHeritages.length === 0 ||
      selectedHeritages.every((heritage) =>
        book.heritage.toLowerCase().includes(heritage.toLowerCase())
      )
    )
    .filter((book: any) =>
      selectedGenres.length === 0 ||
      selectedGenres.every((genre) =>
        book.genres.toLowerCase().includes(genre.toLowerCase())
      )
    )


    // Alphabetical sort by title
    .sort((a: any, b: any) => a.title.localeCompare(b.title));

    function scrollToTop() {
    window.scrollTo(0, 0);
  }

  // Indivisual Card
  const listItems = books.map((book: any) => (
    <li key={book.id}>
      <div className="Card">
        <p className="bookTitle">{book.title}</p>
        <img
          src={`${book.coverURL}`}
          alt="Book cover"
          className="bookCover"
        />
        <p className="bookInfo">Author: {book.authorName}</p>
        <p className="bookInfo">Heritage: {book.heritage}</p>
        <p className="bookInfo">Publisher: {book.publisher}</p>
        <p className="bookInfo">Publication Date: {book.publicationDate}</p>
        <p className="bookInfo">ISBN: {book.isbn}</p>
        <p className="bookInfo">Genre/s: {book.genres}</p>
        <a
          target="_blank"
          href={book.purchaseLinks}
        >
          <button className="buyButton">
            Go To Store 
            <img src={openInNew} alt="Open in new tab" />
          </button>
        </a>
      </div>

      <div className="compactCard">
        <img
          className="compactBookCover"
          src={`${book.coverURL}`}
          alt="Book cover"
        />
        <p className="compactBookTitle">{book.title}</p>
        <a
          className="compactBuyButtonLink"
          target="_blank"
          href={book.purchaseLinks}
        >
          <button className="compactBuyButton">
            Store 
            <img src={openInNew} alt="Open in new tab" />
          </button>
        </a>
      </div>
    </li>
  ));

  return (
    <>
      <center>
        <p className="title">Black British Booklist</p>



        <input
          className="searchBox"
          value={searchTitleText}
          placeholder="Search by title"
          onChange={(e) => setSearchTitleText(e.target.value)}
        />
        <input
          className="searchBox"
          value={searchAuthorText}
          placeholder="Search by author"
          onChange={(e) => setSearchAuthorText(e.target.value)}
        />



        <p className="filterTitle">Filter by Genre</p>
        <div className="chipContainer">
          <Chip
            selected={selectedGenres.includes("Non-Fiction")}
            onClick={() => toggleGenre("Non-Fiction")}
          >
            Non-Fiction
          </Chip>

          <Chip
            selected={selectedGenres.includes("Contemporary Fiction"&&"Literary Fiction")}
            onClick={() => toggleGenre("Contemporary Fiction"&&"Literary Fiction")}
          >
            Contemporary & Literary Fiction
          </Chip>

          <Chip
            selected={selectedGenres.includes("YA")}
            onClick={() => toggleGenre("YA")}
          >
            Young Adult
          </Chip>

          <Chip
            selected={selectedGenres.includes("Middle Grade")}
            onClick={() => toggleGenre("Middle Grade")}
          >
            Middle Grade
          </Chip>

          <Chip
            selected={selectedGenres.includes("Fantasy")}
            onClick={() => toggleGenre("Fantasy")}
          >
            Fantasy
          </Chip>

          <Chip
            selected={selectedGenres.includes("LGBTQ")}
            onClick={() => toggleGenre("LGBTQ")}
          >
            LGBTQ+
          </Chip>

          <Chip
            selected={selectedGenres.includes("Romance")}
            onClick={() => toggleGenre("Romance")}
          >
            Romance
          </Chip>

          <Chip
            selected={selectedGenres.includes("Crime"&&"Thriller")}
            onClick={() => toggleGenre("Crime"&&"Thriller")}
          >
            Crime & Thriller
          </Chip>

          <Chip
            selected={selectedGenres.includes("Horror")}
            onClick={() => toggleGenre("Horror")}
          >
            Horror
          </Chip>

          <Chip
            selected={selectedGenres.includes("Historical Fiction")}
            onClick={() => toggleGenre("Historical Fiction")}
          >
            Historical Fiction
          </Chip>

          <Chip
            selected={selectedGenres.includes("Sci-Fi")}
            onClick={() => toggleGenre("Sci-Fi")}
          >
            Sci-Fi
          </Chip>

          <Chip
            selected={selectedGenres.includes("Poetry")}
            onClick={() => toggleGenre("Poetry")}
          >
            Poetry
          </Chip>
        </div>



        <p className="filterTitle">Filter by Heritage</p>
        <div className="chipContainer">
          <Chip
            selected={selectedHeritages.includes("Jamaican")}
            onClick={() => toggleHeritage("Jamaican")}
          >
            Jamaica 
            <img src="https://em-content.zobj.net/source/apple/453/flag-jamaica_1f1ef-1f1f2.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Nigerian")}
            onClick={() => toggleHeritage("Nigerian")}
          >
            Nigeria
            <img src="https://em-content.zobj.net/source/apple/453/flag-nigeria_1f1f3-1f1ec.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Ghanaian")}
            onClick={() => toggleHeritage("Ghanaian")}
          >
            Ghana
            <img src="https://em-content.zobj.net/source/apple/453/flag-ghana_1f1ec-1f1ed.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Sierra Leoneon")}
            onClick={() => toggleHeritage("Sierra Leoneon")}
          >
            Sierra Leon
            <img src="https://em-content.zobj.net/source/apple/453/flag-sierra-leone_1f1f8-1f1f1.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Barbadian")}
            onClick={() => toggleHeritage("Barbadian")}
          >
            Barbados
            <img src="https://em-content.zobj.net/source/apple/453/flag-barbados_1f1e7-1f1e7.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Guyanese")}
            onClick={() => toggleHeritage("Guyanese")}
          >
            Guyana
            <img src="https://em-content.zobj.net/source/apple/453/flag-guyana_1f1ec-1f1fe.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Trinidadian")}
            onClick={() => toggleHeritage("Trinidadian")}
          >
            Trinidad and Tobago
            <img src="https://em-content.zobj.net/source/apple/453/flag-trinidad-tobago_1f1f9-1f1f9.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Lucian")}
            onClick={() => toggleHeritage("Lucian")}
          >
            St Lucia
            <img src="https://em-content.zobj.net/source/apple/453/flag-st-lucia_1f1f1-1f1e8.png" />
          </Chip>
          
          <Chip
            selected={selectedHeritages.includes("Sudanese")}
            onClick={() => toggleHeritage("Sudanese")}
          >
            Sudan
            <img src="https://em-content.zobj.net/source/apple/453/flag-sudan_1f1f8-1f1e9.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Grenadian")}
            onClick={() => toggleHeritage("Grenadian")}
          >
            Grenada
            <img src="https://em-content.zobj.net/source/apple/453/flag-grenada_1f1ec-1f1e9.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Antigua")}
            onClick={() => toggleHeritage("Antigua")}
          >
            Antigua and Barbuda
            <img src="https://em-content.zobj.net/source/apple/453/flag-antigua-barbuda_1f1e6-1f1ec.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Dominican")}
            onClick={() => toggleHeritage("Dominican")}
          >
            Dominica
            <img src="https://em-content.zobj.net/source/apple/453/flag-dominica_1f1e9-1f1f2.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Somali")}
            onClick={() => toggleHeritage("Somali")}
          >
            Somalia
            <img src="https://em-content.zobj.net/source/apple/453/flag-somalia_1f1f8-1f1f4.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Congolese")}
            onClick={() => toggleHeritage("Congolese")}
          >
            DR Congo
            <img src="https://em-content.zobj.net/source/apple/453/flag-congo-kinshasa_1f1e8-1f1e9.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Zimbabwean")}
            onClick={() => toggleHeritage("Zimbabwean")}
          >
            Zimbabwe
            <img src="https://em-content.zobj.net/source/apple/453/flag-zimbabwe_1f1ff-1f1fc.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Cape Verdean")}
            onClick={() => toggleHeritage("Cape Verdean")}
          >
            Cape Verde
            <img src="https://em-content.zobj.net/source/apple/453/flag-cape-verde_1f1e8-1f1fb.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("St Kittian")}
            onClick={() => toggleHeritage("St Kittian")}
          >
            St Kitts and Nevis
            <img src="https://em-content.zobj.net/source/apple/453/flag-st-kitts-nevis_1f1f0-1f1f3.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Eritrean")}
            onClick={() => toggleHeritage("Eritrean")}
          >
            Eritrea
            <img src="https://em-content.zobj.net/source/apple/453/flag-eritrea_1f1ea-1f1f7.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Ugandan")}
            onClick={() => toggleHeritage("Ugandan")}
          >
            Uganda
            <img src="https://em-content.zobj.net/source/apple/453/flag-uganda_1f1fa-1f1ec.png" />
          </Chip>

          <Chip
            selected={selectedHeritages.includes("Vincentian")}
            onClick={() => toggleHeritage("Vincentian")}
          >
            St Vincent and the Grenadines
            <img src="https://em-content.zobj.net/source/apple/453/flag-st-vincent-grenadines_1f1fb-1f1e8.png" />
          </Chip>
        </div>



        <ul>{listItems}</ul>
        <button className="backToTopButton" onClick={() => scrollToTop()}><img src={arrowUpward} alt="Back to top" /></button>
      </center>
    </>
  );
}

export default App;
